import moment from "moment";
import axioPath from "../../../../api/axioPath";
import { stateConvert } from "web/components/utils/stateAbbreviation";

const getActualQuantityFunc = val => {
  let actualDisplayQuantity = val.orderDetails?.quantity
  let totalClaimQuantity = 0
  if (val.claimDetails?.length > 0) {
    totalClaimQuantity = val.claimDetails.reduce((acc, value) => {
      return acc + value.claimQuantity + value.claimQuality
    }, 0)
  }
  actualDisplayQuantity = actualDisplayQuantity - totalClaimQuantity
  return actualDisplayQuantity
}

const csvfunction = (getData) => {
  let tempCsvData = getData.map(val => {

    // for calculating the remaining quanity in case claim raised scenarios
    let actualDisplayQuantity = getActualQuantityFunc(val)

    let sellerAccNumber = "";
    if (val.sellerInfo.paymentMethodInfo && val.sellerInfo.paymentMethodInfo.paymentMethodDetails) {
      if (val.sellerInfo.paymentMethodInfo.paymentMethodDetails.bankAccount)
        sellerAccNumber = `****${val.sellerInfo.paymentMethodInfo.paymentMethodDetails.bankAccount.last4}`;
      if (val.sellerInfo.paymentMethodInfo.paymentMethodDetails.card)
        sellerAccNumber = `****${val.sellerInfo.paymentMethodInfo.paymentMethodDetails.card.last4Digit}`;
    }
    let buyerFeetoPT = val.buyerInfo.price.productPrice * (val.buyerInfo.price.serviceChargePercent / 100)
    let stripeFee = ((val.buyerInfo.price.productPrice + val.buyerInfo.price.tax + buyerFeetoPT) * (val.stripeFeePercent / 100)) + 0.3
    let claimDetailsTemp
    if (val.claimDetails && val.claimDetails?.length > 0) {
      claimDetailsTemp = val.claimDetails.map(data => {
        return (
          (data.claimQuantity + data.claimQuality) + '-' + (data.issueType) + '-' + (data.status)
        )
      })
    }
    //Buyer-Seller Comments
    let buyerComments = "";
    let sellerComments = "";
    let orderComments = val?.comments;
    orderComments?.length > 0 && orderComments.forEach(item => {
      if (item.userType === "BUYER" && item.comment) {
        buyerComments += (buyerComments.length > 0 ? "-- " : "") + item.comment;
      } else if (item.userType === "SELLER" && item.comment) {
        sellerComments += (sellerComments.length > 0 ? "-- " : "") + item.comment;
      }
    });

    // get size
    const getSize = () => {
      const gradeName = val?.orderDetails?.grade?.gradeName || 'NA';
      if (gradeName === 'Custom') {
        const dim = val?.orderDetails?.dimension;
        if (dim?.length && dim?.width && dim?.height) {
          return `${dim.length}x${dim.width}x${dim.height}`;
        }
        return 'Custom';
      }
      return gradeName;
    };

    let mainOrderReturnObj = {
      BuyerInvoiceNumber: val.buyerInvoiceNumber ? val.buyerInvoiceNumber : 'NA',
      SellerInvoiceNumber: val.sellerInvoiceNumber ? val.sellerInvoiceNumber : 'NA',
      OrderId: val.id,
      PTPlusOrderRefId: val.orderRefNumber ?? "NA",
      PoNumber: val.poNumber ? val.poNumber?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") : 'NA',
      Seller: val.sellerInfo?.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
      SellerStreetAddress: `${val.sellerInfo?.address?.line1?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")} ${val.sellerInfo?.address?.line2?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") ? `-${val.sellerInfo?.address?.line2?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")}` : ''}`,
      SellerCity: val.sellerInfo?.address?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
      SellerState: stateConvert(val.sellerInfo?.address?.state) || val.sellerInfo?.address?.state,
      SellerZipCode: val.sellerInfo?.address?.zip,
      SellerBroker: val.sellerIsReseller ? 'Yes' : 'No',
      SellerFCMember: val.sellerInnerCircle ? 'Yes' : 'No',
      Buyer: val.buyerInfo?.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
      BuyerStreetAddress: `${val.buyerInfo?.address?.line1?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")} ${val.buyerInfo?.address?.line2?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") ? `-${val.buyerInfo?.address?.line2?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")}` : ''}`,
      BuyerCity: val.buyerInfo?.address?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
      BuyerState: stateConvert(val.buyerInfo?.address?.state) || val.buyerInfo?.address?.state,
      BuyerZipCode: val.buyerInfo?.address?.zip,
      BuyerBroker: val.buyerIsReseller ? 'Yes' : 'No',
      BuyerFCMember: val.buyerInnerCircle ? 'Yes' : 'No',
      PostName: val.orderDetails?.title?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
      TransportType: val.contactInfo?.type === "DELIVERABLE" ? "Delivery" : "Pickup",
      Material: val?.orderDetails?.material || 'NA',
      Condition: val?.orderDetails?.condition?.length > 0 ? val.orderDetails.condition : 'NA',
      PalletType: val?.orderDetails?.commodity?.commodityName || 'NA',
      Moisture: val.orderDetails.moistureContent || 'NA',
      Size: getSize(),
      Grade: val?.orderDetails?.grade?.sizeWiseGrad || 'NA',
      HeatTreated: val?.orderDetails?.isHeatTreared ? 'Yes' : 'No',
      Del_PickStreetAddress: `${val.contactInfo?.address?.line1?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")} ${val.contactInfo?.address?.line2?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") ? `-${val.contactInfo?.address?.line2?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")}` : ''}`,
      Del_PickCity: val.contactInfo?.address?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
      Del_PickState: stateConvert(val.contactInfo?.address?.state) || val.contactInfo?.address?.state,
      Del_PickZipCode: val.contactInfo?.address?.zip,
      SalesTaxCode: val.salesTaxCode,
      SalesTaxDescription: val.salesTaxDescription?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
      OrderType: val.orderDetails?.postType === "LOAD" ? "Need" : "Inventory",
      Status: val.orderStatus === 'CANCELLED' ? 'CANCELED' : val.orderStatus,
      ClaimDetails: claimDetailsTemp ? claimDetailsTemp.join(' & ') : 'NA',
      PostedDate: moment(val.orderDetails?.postedOn).format("MM-DD-YYYY"),
      RequestedDate: moment(val.contactInfo?.requestedDateUTC * 1000).format("MM-DD-YYYY"),
      OrderCreationDate: moment(val.created * 1000).format("MM-DD-YYYY"),
      ActualDeliveryDate: val.buyerDeliveryDate ? moment(val.buyerDeliveryDate).format("MM-DD-YYYY") : 'NA',
      SystemUpdatedDate: val.shippingStatusDetails[1]?.created ? moment(val.shippingStatusDetails[1]?.created * 1000).format("MM-DD-YYYY") : 'NA',
      PaymentUpdatedDate: val.paymentStatusDetails?.created ? moment(val.paymentStatusDetails?.created * 1000).format("MM-DD-YYYY") : 'NA',
      BuyerAccNo: `****${val.buyerInfo?.paymentMethodInfo?.paymentMethodDetails?.card?.last4Digit ? val.buyerInfo?.paymentMethodInfo?.paymentMethodDetails?.card?.last4Digit : val.buyerInfo?.paymentMethodInfo?.paymentMethodDetails?.achBankAccount?.last4}`,
      SellerAccNo: sellerAccNumber,
      Quantity: actualDisplayQuantity,
      PaymentStatus: val.paymentStatusDetails?.paymentStatus,
      PaymentType: val.buyerInfo?.paymentMethodInfo?.paymentMethod,
      PayoutDate: val.payoutDetails?.updatedAt ? moment(val.payoutDetails?.updatedAt).format("MM-DD-YYYY") : 'NA',
      PayoutStatus: val.payoutDetails?.status?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") || 'NA',
      UnitPrice: `$ ${val.orderDetails?.pricePerPallet?.toFixed(2)}`,
      ExtendedAmount: `$ ${(val.buyerInfo?.price?.productPrice)?.toFixed(2)}`,
      BuyerDiscount: val.buyerInfo?.price?.buyerDiscountAmount != null ? `$ ${val.buyerInfo.price.buyerDiscountAmount}` : 'NA',
      BuyerDiscountedPrice: val.buyerInfo?.price?.productPriceAfterDiscount != null ? `$ ${val.buyerInfo.price.productPriceAfterDiscount}` : 'NA',
      SellerDiscount: val.sellerInfo?.price?.sellerDiscountAmount != null ? `$ ${val.sellerInfo.price.sellerDiscountAmount}` : 'NA',
      SellerDiscountedPrice: val.sellerInfo?.price?.productPriceAfterDiscount != null ? `$ ${val.sellerInfo.price.productPriceAfterDiscount}` : 'NA',
      CollectionTerm: val.buyerInfo?.price?.pickupTerm != null ? `${val.buyerInfo.price.pickupTerm} days` : 'NA',
      CollectionTermDiscount: val.buyerInfo?.price?.pickupTermDiscount != null ? `${val.buyerInfo.price.pickupTermDiscount.toFixed(1)} %` : 'NA',
      PaymentTerm: val.sellerInfo?.price?.deliveryTerm != null ? `${val.sellerInfo.price.deliveryTerm} days` : 'NA',
      PaymentTermDiscount: val.sellerInfo?.price?.deliveryTermDiscount != null ? `${val.sellerInfo.price.deliveryTermDiscount.toFixed(1)} %` : 'NA',
      Tax: `$ ${val.buyerInfo?.price?.tax?.toFixed(2)}`,
      TaxDiff: val.buyerInfo?.price?.taxDiff ? `$ ${val.buyerInfo?.price?.taxDiff?.toFixed(2)}` : 'NA',
      TaxRate: val.buyerInfo?.price?.taxRate !== "NaN" ? `${val.buyerInfo?.price?.taxRate?.toFixed(2)} %` : "0",
      SellerFee: `$ ${val.sellerInfo?.price?.serviceCharge?.toFixed(2) || 0}`,
      SellerFeePercent: `${val.sellerInfo?.price?.serviceChargePercent?.toFixed(2) || 0} %`,
      ConnectFeePercent: val.sellerInfo?.price?.connectFeePercent ? `${val.sellerInfo?.price?.connectFeePercent?.toFixed(2)} %` : 'NA',
      ConnectFee: val.sellerInfo?.price?.connectFeeAdditional ? `$ ${val.sellerInfo?.price?.connectFeeAdditional?.toFixed(2)}` : 'NA',
      BuyerFee: `$ ${(buyerFeetoPT || 0)?.toFixed(2)}`,
      BuyerFeePercent: `${val.buyerInfo?.price?.serviceChargePercent?.toFixed(2) || 0} %`,
      StripeFee: val.buyerInfo?.paymentMethodInfo?.paymentMethod !== 'ACH_ACCOUNT' ? ` $ ${stripeFee?.toFixed(2)}` : `$ 5`,
      StripeFeeDiff: val.buyerInfo?.price?.stripeFeeDiff ? `$ ${val.buyerInfo?.price?.stripeFeeDiff?.toFixed(2)}` : 'NA',
      StripeFeePercent: val.buyerInfo?.paymentMethodInfo?.paymentMethod !== 'ACH_ACCOUNT' ? `${val.stripeFeePercent?.toFixed(2) || 0} %` : 'NA',
      StripeFeeRefundBuyer: 'NA',
      OtherFee: val.buyerInfo?.paymentMethodInfo?.paymentMethod !== 'ACH_ACCOUNT' ? `$ ${val.otherFees?.toFixed(2)}` : 'NA',
      RefundAmount: val.buyerInfo?.price?.refundAmount ? `$ ${val.buyerInfo?.price?.refundAmount?.toFixed(2)}` : 'NA',
      TotalFeeBuyer: `$ ${(val.buyerInfo.price.serviceCharge - val.buyerInfo.price.tax)?.toFixed(2)}`,
      TotalFeePercentBuyer: `${(((val.buyerInfo.price.serviceCharge - val.buyerInfo.price.tax) / val.buyerInfo?.price?.totalPrice) * 100)?.toFixed(2)} %`,
      TotalAmountBuyer: `$ ${val.buyerInfo?.price?.totalPrice?.toFixed(2)}`,
      TotalAmountSeller: `$ ${val.sellerInfo?.price?.totalPrice?.toFixed(2)}`,
      PTAccountAdjustment: 'NA',
      OtherComments: (val.orderDetails?.description || val.orderCancelDetails?.description) ?
        `${val.orderDetails?.description || ""} ${val.orderCancelDetails?.description || ""}`.replaceAll(",", " ").replaceAll("\n", " ")
        : "NA",
      BuyerComments: buyerComments ? buyerComments?.replaceAll(",", " ").replaceAll("\n", " ") : "NA",
      SellerComments: sellerComments ? sellerComments?.replaceAll(",", " ").replaceAll("\n", " ") : "NA",
    }
    let adjustedOrderReturnObj
    if (val.isAdjusted && val.fundAdjustment) {
      let toalPriceBuyer, totalPriceSeller, totalPricePTAdmin
      if (val.fundAdjustment?.adjustmentType === 'BUYER_AC') {
        toalPriceBuyer = `$ ${val.fundAdjustment?.adjPrice?.buyerTotalPrice}`
        totalPriceSeller = `$ ${val.fundAdjustment?.adjPrice?.sellerTotalPrice}`
        totalPricePTAdmin = 'NA'
      } else if (val.fundAdjustment?.adjustmentType === 'SELLER_AC') {
        toalPriceBuyer = `-$ ${val.fundAdjustment?.adjPrice?.buyerRefundAmount}`
        totalPriceSeller = `-$ ${val.fundAdjustment?.adjPrice?.sellerDeductAmount}`
        totalPricePTAdmin = 'NA'
      } else if (val.fundAdjustment?.adjustmentType === 'PT_AC') {
        toalPriceBuyer = `-$ ${val.fundAdjustment?.adjPrice?.buyerRefundAmount}`
        totalPriceSeller = `NA`
        totalPricePTAdmin = `-$ ${val.fundAdjustment?.adjPrice?.ptPaidAmount}`
      }
      let extendedAmountValue, totalFeeBuyerVal, totalFeeSellerVal, buyerTaxFee, buyerTaxFeeDiff, buyerStripeFee, buyerStripeFeeDiff, totalServiceFeeBuyer, stripeFeeRefundBuyerValue
      if (val.fundAdjustment?.adjustmentType === 'BUYER_AC') {
        extendedAmountValue = `$ ${(val.fundAdjustment?.adjPrice?.adjAmount)?.toFixed(2)}`
        let tempData = val.fundAdjustment?.adChargeDetails
        totalFeeBuyerVal = `$ ${tempData?.buyerPTFee?.toFixed(2) || 0}`
        totalFeeSellerVal = `$ ${tempData?.sellerPTFee?.toFixed(2) || 0}`
        buyerTaxFee = `$ ${tempData?.taxAmount?.toFixed(2)}`
        buyerTaxFeeDiff = `$ ${tempData?.adjTaxDiffAmount?.toFixed(2)}`
        buyerStripeFee = `$ ${tempData?.stripeFee?.toFixed(2)}`
        buyerStripeFeeDiff = `$ ${tempData?.adjStripeFeeDiffAmt?.toFixed(2)}`
        totalServiceFeeBuyer = `$ ${(tempData?.buyerPTFee + tempData?.taxAmount + tempData?.stripeFee)?.toFixed(2)}`
        stripeFeeRefundBuyerValue = 'NA'
      } else {
        extendedAmountValue = `-$ ${(val.fundAdjustment?.adjPrice?.adjAmount)?.toFixed(2)}`
        let tempData = val.fundAdjustment?.adjPrice?.priceDifference
        totalFeeBuyerVal = `-$ ${tempData?.buyerPTFeeDiff?.toFixed(2) || 0}`
        totalFeeSellerVal = `-$ ${tempData?.sellerPTFeeDiff?.toFixed(2) || 0}`
        buyerTaxFee = `-$ ${tempData?.taxDiff?.toFixed(2)}`
        buyerStripeFee = `-$ ${tempData?.stripeFeeDiff?.toFixed(2)}`
        buyerTaxFeeDiff = `-$ ${val.fundAdjustment?.adjPrice?.adjTaxDiffAmount?.toFixed(2)}`
        buyerStripeFeeDiff = `-$ ${val.fundAdjustment?.adjPrice?.adjStripeFeeDiffAmt?.toFixed(2)}`
        totalServiceFeeBuyer = `-$ ${(tempData?.buyerPTFeeDiff + tempData?.taxDiff + tempData?.stripeFeeDiff)?.toFixed(2)}`
        stripeFeeRefundBuyerValue = `-$ ${(tempData?.stripeFeeDiff + val.fundAdjustment?.adjPrice?.adjStripeFeeDiffAmt)?.toFixed(2)}`
      }

      if (val.fundAdjustment?.adjustmentType === 'REFUND_TAX') {
        extendedAmountValue = '$ 0'
        buyerTaxFee = `-$ ${val.buyerInfo?.price?.tax?.toFixed(2)}`
        toalPriceBuyer = `$ ${val.fundAdjustment?.adjPrice?.buyerRefundAmount}`
        totalPriceSeller = '$ 0'
        totalPricePTAdmin = `-$ ${val.fundAdjustment?.adjPrice?.ptPaidAmount}`
      }

      adjustedOrderReturnObj = {
        BuyerInvoiceNumber: val.buyerCreditMemoId,
        SellerInvoiceNumber: val.sellerCreditMemoId,
        OrderId: val.fundAdjustment?.avaOrderId,
        PTPlusOrderRefId: val.orderRefNumber ?? "NA",
        PoNumber: val.poNumber ? val.poNumber?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") : 'NA',
        Seller: val.sellerInfo?.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        SellerStreetAddress: `${val.sellerInfo?.address?.line1?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")} ${val.sellerInfo?.address?.line2?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") ? `-${val.sellerInfo?.address?.line2?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")}` : ''}`,
        SellerCity: val.sellerInfo?.address?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        SellerState: stateConvert(val.sellerInfo?.address?.state) || val.sellerInfo?.address?.state,
        SellerZipCode: val.sellerInfo?.address?.zip,
        SellerBroker: val.sellerIsReseller ? 'Yes' : 'No',
        SellerFCMember: val.sellerInnerCircle ? 'Yes' : 'No',
        Buyer: val.buyerInfo?.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        BuyerStreetAddress: `${val.buyerInfo?.address?.line1?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")} ${val.buyerInfo?.address?.line2?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") ? `-${val.buyerInfo?.address?.line2?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")}` : ''}`,
        BuyerCity: val.buyerInfo?.address?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        BuyerState: stateConvert(val.buyerInfo?.address?.state) || val.buyerInfo?.address?.state,
        BuyerZipCode: val.buyerInfo?.address?.zip,
        BuyerBroker: val.buyerIsReseller ? 'Yes' : 'No',
        BuyerFCMember: val.buyerInnerCircle ? 'Yes' : 'No',
        PostName: val.orderDetails?.title?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        TransportType: val.contactInfo?.type === "DELIVERABLE" ? "Delivery" : "Pickup",
        Material: val?.orderDetails?.material || 'NA',
        Condition: val?.orderDetails?.condition?.length > 0 ? val.orderDetails.condition : 'NA',
        PalletType: val?.orderDetails?.commodity?.commodityName || 'NA',
        Moisture: val.orderDetails.moistureContent || 'NA',
        Size: getSize(),
        Grade: val?.orderDetails?.grade?.sizeWiseGrad || 'NA',
        HeatTreated: val?.orderDetails?.isHeatTreared ? 'Yes' : 'No',
        Del_PickStreetAddress: `${val.contactInfo?.address?.line1?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")} ${val.contactInfo?.address?.line2?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") ? `-${val.contactInfo?.address?.line2?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")}` : ''}`,
        Del_PickCity: val.contactInfo?.address?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        Del_PickState: stateConvert(val.contactInfo?.address?.state) || val.contactInfo?.address?.state,
        Del_PickZipCode: val.contactInfo?.address?.zip,
        SalesTaxCode: val.salesTaxCode,
        SalesTaxDescription: val.salesTaxDescription?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        OrderType: val.orderDetails?.postType === "LOAD" ? "Need" : "Inventory",
        Status: 'ADJUSTMENT',
        ClaimDetails: 'NA',
        PostedDate: moment(val.orderDetails?.postedOn).format("MM-DD-YYYY"),
        RequestedDate: moment(val.contactInfo?.requestedDateUTC * 1000).format("MM-DD-YYYY"),
        OrderCreationDate: moment(val.created * 1000).format("MM-DD-YYYY"),
        ActualDeliveryDate: val.buyerDeliveryDate ? moment(val.buyerDeliveryDate).format("MM-DD-YYYY") : 'NA',
        SystemUpdatedDate: val.shippingStatusDetails[1]?.created ? moment(val.shippingStatusDetails[1]?.created * 1000).format("MM-DD-YYYY") : 'NA',
        PaymentUpdatedDate: val.paymentStatusDetails?.created ? moment(val.paymentStatusDetails?.created * 1000).format("MM-DD-YYYY") : 'NA',
        BuyerAccNo: `****${val.buyerInfo?.paymentMethodInfo?.paymentMethodDetails?.card?.last4Digit ? val.buyerInfo?.paymentMethodInfo?.paymentMethodDetails?.card?.last4Digit : val.buyerInfo?.paymentMethodInfo?.paymentMethodDetails?.achBankAccount?.last4}`,
        SellerAccNo: sellerAccNumber,
        Quantity: val.fundAdjustment?.adjustmentType === 'BUYER_AC' ? val.fundAdjustment?.adjPrice?.adjQty : `-${val.fundAdjustment?.adjPrice?.adjQty}`,
        PaymentStatus: val.paymentStatusDetails?.paymentStatus,
        PaymentType: val.buyerInfo?.paymentMethodInfo?.paymentMethod,
        PayoutDate: val.payoutDetails?.updatedAt ? moment(val.payoutDetails?.updatedAt).format("MM-DD-YYYY") : 'NA',
        PayoutStatus: val.payoutDetails?.status?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") || 'NA',
        UnitPrice: `$ ${val.orderDetails?.pricePerPallet?.toFixed(2)}`,
        ExtendedAmount: extendedAmountValue,
        BuyerDiscount: 'NA',
        BuyerDiscountedPrice: 'NA',
        SellerDiscount: 'NA',
        SellerDiscountedPrice: 'NA',
        CollectionTerm: 'NA',
        CollectionTermDiscount: 'NA',
        PaymentTerm: 'NA',
        PaymentTermDiscount: 'NA',
        Tax: buyerTaxFee,
        TaxDiff: val.buyerInfo?.paymentMethodInfo?.paymentMethod !== 'ACH_ACCOUNT' ? buyerTaxFeeDiff : 'NA',
        TaxRate: val.fundAdjustment?.adjustmentType === 'REFUND_TAX' ? 'NA' : `${val.fundAdjustment?.adjPrice?.taxRate?.toFixed(2)} %`,
        SellerFee: totalFeeSellerVal,
        SellerFeePercent: val.fundAdjustment?.adjustmentType === 'REFUND_TAX' ? 'NA' : `${val.sellerInfo?.price?.serviceChargePercent?.toFixed(2) || 0} %`,
        ConnectFeePercent: val.sellerInfo?.price?.connectFeePercent ? `${val.sellerInfo?.price?.connectFeePercent?.toFixed(2)} %` : 'NA',
        ConnectFee: val.sellerInfo?.price?.connectFeeAdditional ? `$ ${val.sellerInfo?.price?.connectFeeAdditional?.toFixed(2)}` : 'NA',
        BuyerFee: totalFeeBuyerVal,
        BuyerFeePercent: val.fundAdjustment?.adjustmentType === 'REFUND_TAX' ? 'NA' : `${val.fundAdjustment?.adjPrice?.buyerServiceChargePercent?.toFixed(2) || 0} %`,
        StripeFee: buyerStripeFee,
        StripeFeeDiff: val.buyerInfo?.paymentMethodInfo?.paymentMethod !== 'ACH_ACCOUNT' ? buyerStripeFeeDiff : 'NA',
        StripeFeePercent: val.buyerInfo?.paymentMethodInfo?.paymentMethod !== 'ACH_ACCOUNT' ? `${val.stripeFeePercent?.toFixed(2) || 0} %` : 'NA',
        StripeFeeRefundBuyer: stripeFeeRefundBuyerValue,
        OtherFee: val.buyerInfo?.paymentMethodInfo?.paymentMethod !== 'ACH_ACCOUNT' ? `$ ${val.otherFees?.toFixed(2)}` : 'NA',
        RefundAmount: val.buyerInfo?.price?.refundAmount ? `$ ${val.buyerInfo?.price?.refundAmount?.toFixed(2)}` : 'NA',
        TotalFeeBuyer: totalServiceFeeBuyer,
        TotalFeePercentBuyer: val.fundAdjustment?.adjustmentType === 'REFUND_TAX' ? 'NA' : `${(((val.buyerInfo.price.serviceCharge - val.buyerInfo.price.tax) / val.buyerInfo?.price?.totalPrice) * 100)?.toFixed(2)} %`,
        TotalAmountBuyer: toalPriceBuyer,
        TotalAmountSeller: totalPriceSeller,
        PTAccountAdjustment: totalPricePTAdmin,
        OtherComments: val.fundAdjustment?.comments ? val.fundAdjustment?.comments?.replaceAll(",", " ").replaceAll("\n", " ") : 'NA',
        BuyerComments: buyerComments ? buyerComments?.replaceAll(",", " ").replaceAll("\n", " ") : "NA",
        SellerComments: sellerComments ? sellerComments?.replaceAll(",", " ").replaceAll("\n", " ") : "NA",
      }
    }
    let promoCodeDetailsObj
    if (val.promoReport?.promoCode) {
      promoCodeDetailsObj = {
        BuyerInvoiceNumber: val.promoInvoiceId ? val.promoInvoiceId : 'NA',
        SellerInvoiceNumber: 'NA',
        OrderId: `${val.promoReport?.orderId}-PROMO`,
        PTPlusOrderRefId: val.orderRefNumber ?? "NA",
        PoNumber: val.poNumber ? val.poNumber?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") : 'NA',
        Seller: val.sellerInfo?.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        SellerStreetAddress: `${val.sellerInfo?.address?.line1?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")} ${val.sellerInfo?.address?.line2?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") ? `-${val.sellerInfo?.address?.line2?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")}` : ''}`,
        SellerCity: val.sellerInfo?.address?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        SellerState: stateConvert(val.sellerInfo?.address?.state) || val.sellerInfo?.address?.state,
        SellerZipCode: val.sellerInfo?.address?.zip,
        SellerBroker: val.sellerIsReseller ? 'Yes' : 'No',
        SellerFCMember: val.sellerInnerCircle ? 'Yes' : 'No',
        Buyer: val.buyerInfo?.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        BuyerStreetAddress: `${val.buyerInfo?.address?.line1?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")} ${val.buyerInfo?.address?.line2?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") ? `-${val.buyerInfo?.address?.line2?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")}` : ''}`,
        BuyerCity: val.buyerInfo?.address?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        BuyerState: stateConvert(val.buyerInfo?.address?.state) || val.buyerInfo?.address?.state,
        BuyerZipCode: val.buyerInfo?.address?.zip,
        BuyerBroker: val.buyerIsReseller ? 'Yes' : 'No',
        BuyerFCMember: val.buyerInnerCircle ? 'Yes' : 'No',
        PostName: val.orderDetails?.title?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        TransportType: val.contactInfo?.type === "DELIVERABLE" ? "Delivery" : "Pickup",
        Material: val?.orderDetails?.material || 'NA',
        Condition: val?.orderDetails?.condition?.length > 0 ? val.orderDetails.condition : 'NA',
        PalletType: val?.orderDetails?.commodity?.commodityName || 'NA',
        Moisture: val.orderDetails.moistureContent || 'NA',
        Size: getSize(),
        Grade: val?.orderDetails?.grade?.sizeWiseGrad || 'NA',
        HeatTreated: val?.orderDetails?.isHeatTreared ? 'Yes' : 'No',
        Del_PickStreetAddress: `${val.contactInfo?.address?.line1?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")} ${val.contactInfo?.address?.line2?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") ? `-${val.contactInfo?.address?.line2?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")}` : ''}`,
        Del_PickCity: val.contactInfo?.address?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        Del_PickState: stateConvert(val.contactInfo?.address?.state) || val.contactInfo?.address?.state,
        Del_PickZipCode: val.contactInfo?.address?.zip,
        SalesTaxCode: val.salesTaxCode,
        SalesTaxDescription: val.salesTaxDescription?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        OrderType: val.orderDetails?.postType === "LOAD" ? "Need" : "Inventory",
        Status: val.orderStatus === 'CANCELLED' ? 'CANCELED' : val.orderStatus,
        ClaimDetails: 'NA',
        PostedDate: moment(val.orderDetails?.postedOn).format("MM-DD-YYYY"),
        RequestedDate: moment(val.contactInfo?.requestedDateUTC * 1000).format("MM-DD-YYYY"),
        OrderCreationDate: moment(val.created * 1000).format("MM-DD-YYYY"),
        ActualDeliveryDate: val.buyerDeliveryDate ? moment(val.buyerDeliveryDate).format("MM-DD-YYYY") : 'NA',
        SystemUpdatedDate: val.promoReport?.refundDateTime ? moment(val.promoReport?.refundDateTime).format("MM-DD-YYYY") : 'NA',
        PaymentUpdatedDate: 'NA',
        BuyerAccNo: `****${val.buyerInfo?.paymentMethodInfo?.paymentMethodDetails?.card?.last4Digit ? val.buyerInfo?.paymentMethodInfo?.paymentMethodDetails?.card?.last4Digit : val.buyerInfo?.paymentMethodInfo?.paymentMethodDetails?.achBankAccount?.last4}`,
        SellerAccNo: 'NA',
        Quantity: 'NA',
        PaymentStatus: val.promoReport?.transactionStatus ? val.promoReport?.transactionStatus : 'NA',
        PaymentType: 'NA',
        PayoutDate: 'NA',
        PayoutStatus: 'NA',
        UnitPrice: 'NA',
        ExtendedAmount: `-$ ${(val.promoReport?.discountAmount)?.toFixed(2)}`,
        BuyerDiscount: 'NA',
        BuyerDiscountedPrice: 'NA',
        SellerDiscount: 'NA',
        SellerDiscountedPrice: 'NA',
        CollectionTerm: 'NA',
        CollectionTermDiscount: 'NA',
        PaymentTerm: 'NA',
        PaymentTermDiscount: 'NA',
        Tax: 'NA',
        TaxDiff: 'NA',
        TaxRate: 'NA',
        SellerFee: 'NA',
        SellerFeePercent: 'NA',
        ConnectFeePercent: 'NA',
        ConnectFee: 'NA',
        BuyerFee: 'NA',
        BuyerFeePercent: 'NA',
        StripeFee: 'NA',
        StripeFeeDiff: 'NA',
        StripeFeePercent: 'NA',
        StripeFeeRefundBuyer: 'NA',
        OtherFee: 'NA',
        RefundAmount: 'NA',
        TotalFeeBuyer: 'NA',
        TotalFeePercentBuyer: 'NA',
        TotalAmountBuyer: 'NA',
        TotalAmountSeller: 'NA',
        PTAccountAdjustment: `$ ${(val.promoReport?.discountAmount)?.toFixed(2)}`,
        OtherComments: val.promoReport?.promoDetails,
        BuyerComments: buyerComments ? buyerComments?.replaceAll(",", " ").replaceAll("\n", " ") : "NA",
        SellerComments: sellerComments ? sellerComments?.replaceAll(",", " ").replaceAll("\n", " ") : "NA",
      }
    }
    if (adjustedOrderReturnObj && promoCodeDetailsObj) return ([mainOrderReturnObj, adjustedOrderReturnObj, promoCodeDetailsObj])
    else if (adjustedOrderReturnObj) return ([mainOrderReturnObj, adjustedOrderReturnObj])
    else if (promoCodeDetailsObj) return ([mainOrderReturnObj, promoCodeDetailsObj])
    else return (mainOrderReturnObj)
  })
  // setCsvData(tempCsvData.flat())
  const finalCsvData = tempCsvData.flat()
  return finalCsvData;
}

const getCsvData = (filterDataTemp, page, searchKey) => {
  return new Promise((resolve, _reject) => {
    const token = localStorage.getItem("token")
    let url = `order/admin/order_report?month=${filterDataTemp.month}&year=${filterDataTemp.year}&userType=${filterDataTemp.userType}&city=${filterDataTemp.city}&state=${filterDataTemp.state}&size=100&sort=DESC&page=${page}&searchBy=${searchKey}`
    axioPath.get(url, {
      headers: {
        Authorization: token,
        companyName: filterDataTemp.companyName,
        ...(filterDataTemp.status !== 'All' && { orderStatus: filterDataTemp.status })
      },
    })
      .then((response) => {
        if (response.data.status === 'SUCCESS') {
          if (response.data.payload) {
            let userSubList = response.data.payload
            resolve(userSubList)
          }
        } else {
          resolve({})
        }
      })
      .catch((_ex) => {
        resolve({})
      })
  })
}

let csvFinalData = [];
const handleCsvExportClick = async (filterData, currentPage, searchKey, setCsvCurrentPage, setCsvTotalPages, setIsDownloadingOrderReportCSV, setCsvOrderReportData) => {
  if (currentPage === 1) {
    csvFinalData = [];
  }

  const userSubList = await getCsvData(filterData, currentPage, searchKey);
  let tempData1 = Object.values(userSubList)
  let initialData = (tempData1[0] && tempData1[0].length > 0) ? Object.values(tempData1[0]) : []
  let tempDataSorted = initialData.flat().sort((a, b) => b.created - a.created)

  const totalPages = userSubList?.pageableDTO?.totalPages ?? 1;
  setCsvTotalPages(totalPages)
  csvFinalData.push(...tempDataSorted)

  if (totalPages > currentPage) {
    const nextPage = currentPage + 1;
    setCsvCurrentPage(nextPage)
    handleCsvExportClick(filterData, nextPage, searchKey, setCsvCurrentPage, setCsvTotalPages, setIsDownloadingOrderReportCSV, setCsvOrderReportData)
    return;
  }
  // return csvfunction(csvFinalData)
  const preparedCsvData = csvfunction(csvFinalData)
  setIsDownloadingOrderReportCSV(false)
  setCsvOrderReportData(preparedCsvData);

  const csvExportRef = document.querySelector("#csvExportRef")
  if (csvExportRef) {
    setTimeout(() => {
      csvExportRef.click();
    }, 500);
  }

}


export const ExportOrderReport = (filterData, currentPage, searchKey, setCsvCurrentPage, setCsvTotalPages, setIsDownloadingOrderReportCSV, setCsvOrderReportData) => {
  setIsDownloadingOrderReportCSV(true)
  handleCsvExportClick(filterData, currentPage, searchKey, setCsvCurrentPage, setCsvTotalPages, setIsDownloadingOrderReportCSV, setCsvOrderReportData)
}

export const csvOrderReportHeaderArray = [
  { id: 'BuyerInvoiceNumber', displayName: 'Buyer Invoice Number' },
  { id: 'SellerInvoiceNumber', displayName: 'Seller Invoice Number' },
  { id: 'OrderId', displayName: 'Order Id' },
  { id: 'PTPlusOrderRefId', displayName: 'PT+ Order Reference Number' },
  { id: 'PoNumber', displayName: 'PO Number' },
  { id: 'Seller', displayName: 'Seller' },
  { id: 'SellerStreetAddress', displayName: 'Seller Street Address' },
  { id: 'SellerCity', displayName: 'Seller City' },
  { id: 'SellerState', displayName: 'Seller State' },
  { id: 'SellerZipCode', displayName: 'Seller Zip Code' },
  { id: 'SellerBroker', displayName: 'Seller Broker' },
  { id: 'SellerFCMember', displayName: 'Seller FC Member' },
  { id: 'Buyer', displayName: 'Buyer' },
  { id: 'BuyerStreetAddress', displayName: 'Buyer Street Address' },
  { id: 'BuyerCity', displayName: 'Buyer City' },
  { id: 'BuyerState', displayName: 'Buyer State' },
  { id: 'BuyerZipCode', displayName: 'Buyer Zip Code' },
  { id: 'BuyerBroker', displayName: 'Buyer Broker' },
  { id: 'BuyerFCMember', displayName: 'Buyer FC Member' },
  { id: 'PostName', displayName: 'Post Name' },
  { id: 'TransportType', displayName: 'Transport Type' },
  { id: 'Material', displayName: 'Material' },
  { id: 'Condition', displayName: 'Condition' },
  { id: 'PalletType', displayName: 'Pallet Type' },
  { id: 'Moisture', displayName: 'Moisture' },
  { id: 'Size', displayName: 'Size' },
  { id: 'Grade', displayName: 'Grade' },
  { id: 'HeatTreated', displayName: 'Heat Treated' },
  { id: 'Del_PickStreetAddress', displayName: 'Delivery/Pick Up Street Address' },
  { id: 'Del_PickCity', displayName: 'Delivery/Pick Up City' },
  { id: 'Del_PickState', displayName: 'Delivery/Pick Up State' },
  { id: 'Del_PickZipCode', displayName: 'Delivery/Pick Up Zip Code' },
  { id: 'SalesTaxCode', displayName: 'Sales Tax Code' },
  { id: 'SalesTaxDescription', displayName: 'Sales Tax Description' },
  { id: 'OrderType', displayName: 'Order Type' },
  { id: 'Status', displayName: 'Status' },
  { id: 'ClaimDetails', displayName: 'Claim Details(Qty-Issue Type-Claim Status)' },
  { id: 'PostedDate', displayName: 'Post Date' },
  { id: 'RequestedDate', displayName: 'Requested Date' },
  { id: 'OrderCreationDate', displayName: 'Order Created Date' },
  { id: 'ActualDeliveryDate', displayName: 'Actual Delivery Date' },
  { id: 'SystemUpdatedDate', displayName: 'System Updated Date' },
  { id: 'PaymentUpdatedDate', displayName: 'Payment Updated Date' },
  { id: 'BuyerAccNo', displayName: 'Buyer A/c No.' },
  { id: 'SellerAccNo', displayName: 'Seller A/c No.' },
  { id: 'Quantity', displayName: 'Quantity' },
  { id: 'PaymentStatus', displayName: 'Payment Status' },
  { id: 'PaymentType', displayName: 'Payment Type' },
  { id: 'PayoutDate', displayName: 'Payout Date' },
  { id: 'PayoutStatus', displayName: 'Payout Status' },
  { id: 'UnitPrice', displayName: 'Unit Price' },
  { id: 'ExtendedAmount', displayName: 'Extended Amount' },
  // { id: 'BuyerDiscount', displayName: 'Buyer Discount Amount' },
  // { id: 'BuyerDiscountedPrice', displayName: 'Discounted Buyer Product Price' },
  { id: 'SellerDiscount', displayName: 'Discount Amount' },
  { id: 'SellerDiscountedPrice', displayName: 'Amount Due after Discount' },
  // { id: 'CollectionTerm', displayName: 'Collection Terms' },
  // { id: 'CollectionTermDiscount', displayName: 'Collection Terms Discount' },
  { id: 'PaymentTerm', displayName: 'Payment Terms' },
  { id: 'PaymentTermDiscount', displayName: 'Payment Terms Discount' },
  { id: 'Tax', displayName: 'Tax' },
  { id: 'TaxDiff', displayName: 'Tax Diff' },
  { id: 'TaxRate', displayName: 'Tax Rate %' },
  { id: 'SellerFee', displayName: 'Seller Fee to PT' },
  { id: 'SellerFeePercent', displayName: 'Seller Fee %' },
  { id: 'ConnectFeePercent', displayName: 'Seller Connect Fee %' },
  { id: 'ConnectFee', displayName: 'Seller Connect Fee' },
  { id: 'BuyerFee', displayName: 'Buyer Fee to PT' },
  { id: 'BuyerFeePercent', displayName: 'Buyer Fee %' },
  { id: 'StripeFee', displayName: 'Stripe Fee' },
  { id: 'StripeFeeDiff', displayName: 'Circular Stripe Fee Diff' },
  { id: 'StripeFeePercent', displayName: 'Stripe Fee %' },
  { id: 'StripeFeeRefundBuyer', displayName: 'Stripe Fee Refund To Buyer from PT AC' },
  { id: 'OtherFee', displayName: 'Stripe Other Fees' },
  { id: 'RefundAmount', displayName: 'Refund Amount' },
  { id: 'TotalFeeBuyer', displayName: 'Total Fees Buyer(Other Fee (Service & Stripe Fee))' },
  { id: 'TotalFeePercentBuyer', displayName: 'Total Fee Buyer %' },
  { id: 'TotalAmountBuyer', displayName: 'Total Amount Buyer' },
  { id: 'TotalAmountSeller', displayName: 'Total Amount Seller' },
  { id: 'PTAccountAdjustment', displayName: 'PT Account Adjustment' },
  { id: 'OtherComments', displayName: 'Other Comments' },
  { id: 'BuyerComments', displayName: 'Buyer Comments' },
  { id: 'SellerComments', displayName: 'Seller Comments' },
]